import { Trans } from 'react-i18next'

import worldMapPng from '~/assets/images/anatomyV2/social-proof-map.png'
import worldMapWebp from '~/assets/images/anatomyV2/social-proof-map.webp'

import { Styles as S } from './styles'

interface IRatingsAnatomyWorldMapProps {
  onContinue: () => void
}

const RatingsAnatomyWorldMap = ({
  onContinue,
}: IRatingsAnatomyWorldMapProps) => (
  <S.StyledContainer>
    <S.WorldMapContent>
      <S.WorldMapTitle>
        <Trans ns="anatomy" i18nKey="onboarding.ratingsAnatomy.title" />
      </S.WorldMapTitle>

      <S.WorldMapReviewText>
        <Trans ns="anatomy" i18nKey="onboarding.ratingsAnatomy.reviewText" />
      </S.WorldMapReviewText>

      <S.WorldMapReviewSource>
        –{' '}
        <Trans ns="anatomy" i18nKey="onboarding.ratingsAnatomy.reviewSource" />
      </S.WorldMapReviewSource>

      <picture>
        <source srcSet={worldMapWebp} type="image/webp" />
        <S.WorldMapImage src={worldMapPng} alt="Learners worldwide" />
      </picture>
    </S.WorldMapContent>

    <S.StyledButton type="button" onClick={onContinue}>
      <Trans i18nKey="actions.continue" />
    </S.StyledButton>
  </S.StyledContainer>
)

export default RatingsAnatomyWorldMap
